<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="close">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                    <div class="modal-content p-2">
                        <div v-if="isUserDetailPanel">
                            <div v-if="readOnly">
                                <ViewUserDetailReadonly
                                    ref="view_user_readonly" 
                                    :userId="userId"
                                    :accountId="accountId" 
                            />
                            </div>
                            <div v-else>
                                <ViewUserDetailManage v-if="!readOnly"
                                    ref="view_user_manage" 
                                    :locuserId="userId" 
                                    :locaccountId="accountId"
																		:locPageFlag="flag"
																		:pageIndex="index"
																		:userLists="userLists"
                                />
                            </div>
                        </div>
                        <div v-else>
                            <div class="modal-header">
                              <div class="" style="width: 100%;">
                                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close float-right" @click="hide">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                <div class="clearfix"></div>
                              </div>

                            </div>
                            <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h3 d-inline mr-2 text-uppercase col-12 p-0">{{ account.accountName }}</div>
                              <div :class="' ' + getFontColor(account.status)" class="h5 mr-2 col-12 p-0">{{ account.status }} Location</div>
                              
                            </div>
                            <div class="col-3 pl-3">
                                <button v-if="!readOnly" @click="openNewUserForm" type="button" class="btn btn-primary btn-sm dbAddNewUserBtn ma-blue-btn" style="padding: 5px 25px; border-radius: 15px;">Add New User</button>
                            </div>
                          </div>                            
                                <div class="col-xs-12 override-padding">
                                    <div @click="tabEvent('OverviewTab')" :class="'offcanvas_header offcanvas_heading_1' + (selectedComponent === 'OverviewTab' ? ' active' : '')">Overview</div>
                                    <div @click="tabEvent('UsersTab')" :class="'offcanvas_header offcanvas_heading_2'  + (selectedComponent === 'UsersTab' ? ' active' : '')">Users</div>
                                    <div @click="tabEvent('ResourcesTab')" :class="'offcanvas_header offcanvas_heading_3'  + (selectedComponent === 'ResourcesTab' ? ' active' : '')">Resources</div>
                                    <div v-if="!readOnly" @click="tabEvent('LicenseTab')" :class="'offcanvas_header offcanvas_heading_4'  + (selectedComponent === 'LicenseTab' ? ' active' : '')">License</div>
                                    <div @click="tabEvent('ReportsTab')" :class="'offcanvas_header offcanvas_heading_5'  + (selectedComponent === 'ReportsTab' ? ' active' : '')">Reports</div>
                                    <div v-if="!readOnly" @click="tabEvent('SettingsTab')" :class="'offcanvas_header offcanvas_heading_6'  + (selectedComponent === 'SettingsTab' ? ' active' : '')">Settings</div>
                                </div>
                                <div style="clear: both;"></div>
                                <div class="offcanvas_tab_body">
                                    <component 
                                        :is="selectedComponent" 
                                        :ref="selectedComponent" 
                                        :accountId="accountId" 
                                        :readOnly="readOnly" 
                                    />
                                </div>
                            </div>
                            <div class="modal-footer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <AddNewUser v-if="!readOnly"
            :isModalAddUserToLocationVisible="isModalAddUserToLocationVisible" 
            :accountId="accountId"
            :accountName="account.accountName"
            @close="closeNewUserSidebar"
            ref="add_new_user" 
        />

				<MenteeViewUserDetails
					:isModalVisible="isMenteeViewUserDetailsModalVisible" 
					@close="closeMenteeViewUserDetailsModal"
					ref="MenteeViewUserDetails"
					:readOnly="isReadOnly" 
				/>

    </div>
</template>
<script>
import axios from 'axios';
import OverviewTab from './overview_tab.vue';
import UsersTab from './users_tab.vue';
import ResourcesTab from './resources_tab.vue';
import LicenseTab from './license_tab.vue';
import ReportsTab from './reports_tab.vue';
import SettingsTab from './settings_tab.vue';
import ViewUserDetailReadonly from './view_user_detail_readonly.vue';
import ViewUserDetailManage from './view_user_detail_manage.vue';
import AddNewUser from './add_new_user.vue';
import router from '../../router/index';
import MenteeViewUserDetails from './mentee_view_user_detail_manage.vue';

export default {
    props: ['isModalVisible', 'readOnly'],
    data() {
        return {
            selectedComponent: 'OverviewTab',
            account: [],
            accountId: '',
            isUserDetailPanel: false,
            userId: '',
            overview: {},
            isModalAddUserToLocationVisible: false,
            accountId: '',
            page_from: '',
						isMenteeViewUserDetailsModalVisible: false,
						flag: false,
						index: 0,
						userLists: [],
        }
    },
    components: {
        OverviewTab,
        UsersTab,
        ResourcesTab,
        LicenseTab,
        ReportsTab,
        SettingsTab,
        ViewUserDetailManage,
        ViewUserDetailReadonly,
        AddNewUser,
				MenteeViewUserDetails,
    },
    methods: {
			closeMenteeViewUserDetailsModal() {
				this.isMenteeViewUserDetailsModalVisible = false;
				this.$refs.UsersTab.getListofAllUsers();
			},
			openMenteeViewUserDetailsModal(userId, accountId) {
				var flag = 0;
        if (this.readOnly == true) {
          flag = 1;
        } else {
					flag = 0;
        }
				if (flag == 0) {
					this.isMenteeViewUserDetailsModalVisible = true;
					var userLists = [];
					this.$refs.MenteeViewUserDetails.loadinitial(userId, accountId, 'false', 0, userLists);
				} else {
					this.navigateUserDetail(userId, accountId);
				}
			},
        hide() {
            this.close();
        },
        close() {
            this.$emit('close');
        },
        tabEvent(tabname) {
            this.selectedComponent = tabname;
            if (tabname == "OverviewTab") {
                this.getLocationDetail(this.accountId);
            }
        },
        getFontColor(status) {
            if (status === 'Active') 
                return 'text-green';
            else 
                return 'text-red';
        },
        getLocationDetail(accountId) {
					this.isUserDetailPanel = false;
            if (accountId > 0) {
                this.accountId = accountId;
                this.loading = true;
                this.account = [];
                this.overview = {};
                axios('/enterprise-admin/location-overview',
                {
                    method: 'GET',
                    params: {
                        account_id: accountId,
                    }
                })
                .then(resp => {
                    this.loading = false;
                    this.account = resp.data;
                    if(this.account.address2) {
                        this.overview.address = this.account.address + ' ' + this.account.address2;
                    }
                    else {
                        this.overview.address = this.account.address;
                    }
                    this.overview.city = this.account.city;
                    this.overview.state = this.account.state;
                    this.overview.countryCode = this.account.countryCode;
                    this.overview.zip = this.account.zip;
                    this.overview.phone_number = this.account.phoneNumber;
                    this.overview.primary_admin_id = this.account.primary_admin_id;
                    this.overview.primary_fname = this.account.primary_fname;
                    this.overview.primary_lname = this.account.primary_lname;
                    this.overview.primary_email = this.account.primary_email;
                    this.overview.primary_phone_number = this.account.primary_phone_number;
                    this.overview.subscriptionName = this.account.subscriptionName;
                    this.overview.subscriptionPrice = this.account.subscriptionPrice;
                    this.overview.subscriptionValidityDuration = this.account.subscriptionValidityDuration;
                    this.overview.expirationDate = this.account.expirationDate;
                    this.overview.renewFlag = this.account.renewFlag;
                    this.overview.activeLicense = this.account.activeLicense;
                    this.overview.usedLicense = this.account.usedLicense;
                    this.$refs.OverviewTab.setOverview(this.overview);
                })
                .catch(() => {
                });
            }
        },
        navigateUserDetail(userId, accountId) {
            this.isUserDetailPanel = true;
            this.userId = userId;
            this.accountId = accountId;
						this.flag = false;
						this.index = 0;
						this.userLists = [];
						setTimeout(() => { 
							this.$refs.view_user_manage.loadinitial();
						}, 50);	
        },
        editUserDetail(userId, accountId, flag, index, userLists) {
            this.isUserDetailPanel = true;
            this.userId = userId;
            this.accountId = accountId;
						this.userLists = userLists;
						this.flag = flag;
						this.index = index;
            this.page_from = 'users_toggle_menu';
						setTimeout(() => { 
							this.$refs.view_user_manage.loadinitial();
						}, 50);	
        },
        closeUserDetail(){
            if (this.page_from) {
                router.push(this.$route.path);
                window.location.reload();
            } else {
                this.isUserDetailPanel = false;
            }
        },
        openNewUserForm() {
            this.selectedComponent = "UsersTab";
            this.isModalAddUserToLocationVisible = true;
            this.$refs.add_new_user.loadInitialData();
        },
        closeNewUserSidebar() {
            this.selectedComponent = "UsersTab";
            this.$refs.UsersTab.getListofAllUsers();
            this.isModalAddUserToLocationVisible = false;
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }

/* custom css */
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-sub-title { font-size: 12px; font-weight: 500; }
.active:after {
    content: "";
    display: block;
    margin: 0;
    width: 50%;
    padding-top: 10px;
    border-bottom: 2px solid #00acee;
}
.offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.offcanvas_heading_1 { width: 20%; }
.offcanvas_heading_2 { width: 15%; }
.offcanvas_heading_3 { width: 20%; }
.offcanvas_heading_4 { width: 15%; }
.offcanvas_heading_5 { width: 15%; }
.offcanvas_heading_6 { width: 15%; }
.offcanvas_tab_body { width: 100%; margin: 15px 0; }
.dbAddNewUserBtn {
  color: #FFF;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
}
.dbAddNewUserBtn:active, .dbAddNewUserBtn:focus, .dbAddNewUserBtn:hover {
  color: #FFF !important;
}
.text-green { color: #28a745; font-weight: 900; }
.text-red { color: #dc3545; font-weight: 900; }

.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.maheading_3 .close { padding: 0px !important; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterpriseadmin_overlay_sidebar.vue